import {
    DOCUMENT_TEMPLATE_LIST_REQUEST, DOCUMENT_TEMPLATE_LIST_SUCCESS, DOCUMENT_TEMPLATE_LIST_FAIL,
    DOCUMENT_TEMPLATE_LIST_BY_IDS_REQUEST, DOCUMENT_TEMPLATE_LIST_BY_IDS_SUCCESS, DOCUMENT_TEMPLATE_LIST_BY_IDS_FAIL,
    DOCUMENT_TEMPLATE_DETAILS_REQUEST, DOCUMENT_TEMPLATE_DETAILS_SUCCESS, DOCUMENT_TEMPLATE_DETAILS_FAIL, DOCUMENT_TEMPLATE_DETAILS_RESET,
    DOCUMENT_TEMPLATE_CREATE_REQUEST, DOCUMENT_TEMPLATE_CREATE_SUCCESS, DOCUMENT_TEMPLATE_CREATE_FAIL, DOCUMENT_TEMPLATE_CREATE_RESET,
    DOCUMENT_TEMPLATE_UPDATE_REQUEST, DOCUMENT_TEMPLATE_UPDATE_SUCCESS, DOCUMENT_TEMPLATE_UPDATE_FAIL, DOCUMENT_TEMPLATE_UPDATE_RESET,
    DOCUMENT_TEMPLATE_DELETE_REQUEST, DOCUMENT_TEMPLATE_DELETE_SUCCESS, DOCUMENT_TEMPLATE_DELETE_FAIL, DOCUMENT_TEMPLATE_DELETE_RESET,
    DOCUMENT_TEMPLATE_DTO_REQUEST, DOCUMENT_TEMPLATE_DTO_SUCCESS, DOCUMENT_TEMPLATE_DTO_FAIL, DOCUMENT_TEMPLATE_DTO_RESET,
    SET_CURRENT_PAGE,
    DOCUMENT_TEMPLATE_PUBLIC_LIST_REQUEST, DOCUMENT_TEMPLATE_PUBLIC_LIST_SUCCESS, DOCUMENT_TEMPLATE_PUBLIC_LIST_FAIL, DOCUMENT_TEMPLATE_PUBLIC_LIST_RESET,
} from '../constants/documentTemplateConstants';

export const documentTemplateListReducer = (state = { documentTemplates: [] }, action) => {
    switch (action.type) {
        case DOCUMENT_TEMPLATE_LIST_REQUEST:
            return { loading: true, documentTemplates: [] };
        case DOCUMENT_TEMPLATE_LIST_SUCCESS:
            return {
                loading: false,
                documentTemplates: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
            };
        case SET_CURRENT_PAGE:
            return {
                ...state,
                currentPage: action.payload
            };
        case DOCUMENT_TEMPLATE_LIST_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const documentTemplateListByIdsReducer = (state = { documentTemplates: [] }, action) => {
    switch (action.type) {
        case DOCUMENT_TEMPLATE_LIST_BY_IDS_REQUEST:
            return { loading: true, documentTemplates: [] };
        case DOCUMENT_TEMPLATE_LIST_BY_IDS_SUCCESS:
            return {
                loading: false,
                documentTemplates: action.payload,
            };
        case DOCUMENT_TEMPLATE_LIST_BY_IDS_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const documentTemplateDetailsReducer = (state = { documentTemplate: {} }, action) => {
    switch (action.type) {
        case DOCUMENT_TEMPLATE_DETAILS_REQUEST:
            return { loading: true, ...state };
        case DOCUMENT_TEMPLATE_DETAILS_SUCCESS:
            return { loading: false, documentTemplate: action.payload };
        case DOCUMENT_TEMPLATE_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case DOCUMENT_TEMPLATE_DETAILS_RESET:
            return { documentTemplate: {} };
        default:
            return state;
    }
};

export const documentTemplateDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case DOCUMENT_TEMPLATE_DELETE_REQUEST:
            return { loading: true };
        case DOCUMENT_TEMPLATE_DELETE_SUCCESS:
            return { loading: false, success: true };
        case DOCUMENT_TEMPLATE_DELETE_FAIL:
            return { loading: false, error: action.payload };
        case DOCUMENT_TEMPLATE_DELETE_RESET:
            return {};
        default:
            return state;
    }
};

export const documentTemplateCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case DOCUMENT_TEMPLATE_CREATE_REQUEST:
            return { loading: true };
        case DOCUMENT_TEMPLATE_CREATE_SUCCESS:
            return { loading: false, success: true, documentTemplate: action.payload };
        case DOCUMENT_TEMPLATE_CREATE_FAIL:
            return { loading: false, error: action.payload };
        case DOCUMENT_TEMPLATE_CREATE_RESET:
            return {};
        default:
            return state;
    }
};

export const documentTemplateUpdateReducer = (state = { documentTemplate: {} }, action) => {
    switch (action.type) {
        case DOCUMENT_TEMPLATE_UPDATE_REQUEST:
            return { loading: true };
        case DOCUMENT_TEMPLATE_UPDATE_SUCCESS:
            return { loading: false, success: true, documentTemplate: action.payload };
        case DOCUMENT_TEMPLATE_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case DOCUMENT_TEMPLATE_UPDATE_RESET:
            return { documentTemplate: {} };
        default:
            return state;
    }
};

export const documentTemplateDtoReducer = (state = { documentTemplateDto: {} }, action) => {
    switch (action.type) {
        case DOCUMENT_TEMPLATE_DTO_REQUEST:
            return { loading: true, documentTemplateDto: {} };
        case DOCUMENT_TEMPLATE_DTO_SUCCESS:
            return { loading: false, documentTemplateDto: action.payload };
        case DOCUMENT_TEMPLATE_DTO_FAIL:
            return { loading: false, error: action.payload };
        case DOCUMENT_TEMPLATE_DTO_RESET:
            return { documentTemplateDto: {} };
        default:
            return state;
    }
};

export const documentTemplatePublicListReducer = (state = { documentTemplates: [] }, action) => {
    switch (action.type) {
        case DOCUMENT_TEMPLATE_PUBLIC_LIST_REQUEST:
            return { loading: true, documentTemplates: [] };
        case DOCUMENT_TEMPLATE_PUBLIC_LIST_SUCCESS:
            return {
                loading: false,
                documentTemplates: action.payload.templates,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
            };
        case DOCUMENT_TEMPLATE_PUBLIC_LIST_FAIL:
            return { loading: false, error: action.payload };
        case DOCUMENT_TEMPLATE_PUBLIC_LIST_RESET:
            return { documentTemplates: [] };
        default:
            return state;
    }
}; 